import { Link } from "react-router-dom";
import { Instagram, Mail, Phone, MessageCircle, Linkedin } from "lucide-react";

export default function Footer() {
  return (
    <footer className="border-t border-white/5 bg-[#08080a] mt-24">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 grid md:grid-cols-4 gap-12">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-9 h-9 rounded-md border border-[#D4AF37]/60 grid place-items-center font-serif text-[#D4AF37]">
              A
            </div>
            <div className="font-serif text-xl text-white">ANV Asesores</div>
          </div>
          <p className="text-zinc-400 max-w-md leading-relaxed">
            Más de 25 años acompañando a empresas y autónomos en su día a día fiscal, contable, laboral y mercantil. Cataluña.
          </p>
        </div>

        <div>
          <div className="text-xs uppercase tracking-[0.24em] text-zinc-500 mb-4">Navegación</div>
          <ul className="space-y-2 text-zinc-300">
            <li><Link to="/servicios" className="hover:text-[#D4AF37]">Servicios</Link></li>
            <li><Link to="/sobre-nosotros" className="hover:text-[#D4AF37]">Sobre nosotros</Link></li>
            <li><Link to="/blog" className="hover:text-[#D4AF37]">Blog</Link></li>
            <li><Link to="/contacto" className="hover:text-[#D4AF37]">Contacto</Link></li>
            <li><Link to="/login" className="hover:text-[#D4AF37]">Área cliente</Link></li>
          </ul>
        </div>

        <div>
          <div className="text-xs uppercase tracking-[0.24em] text-zinc-500 mb-4">Contacto</div>
          <ul className="space-y-3 text-zinc-300">
            <li className="flex items-center gap-2"><Phone className="w-4 h-4 text-[#D4AF37]" /> <a href="tel:+34689183582">689 183 582</a></li>
            <li className="flex items-center gap-2"><Mail className="w-4 h-4 text-[#D4AF37]" /> <a href="mailto:info@anvasesores.es">info@anvasesores.es</a></li>
            <li className="flex items-center gap-2"><MessageCircle className="w-4 h-4 text-[#D4AF37]" /> <a href="https://api.whatsapp.com/send?phone=34689183582" target="_blank" rel="noreferrer">WhatsApp</a></li>
            <li className="flex items-center gap-2"><Instagram className="w-4 h-4 text-[#D4AF37]" /> <a href="https://instagram.com/asesoresanv/" target="_blank" rel="noreferrer">@asesoresanv</a></li>
            <li className="flex items-center gap-2"><Linkedin className="w-4 h-4 text-[#D4AF37]" /> <a href="https://www.linkedin.com/company/acta-non-verba-s-l/?viewAsMember=true" target="_blank" rel="noreferrer">Acta Non Verba, S.L.</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/5 py-6 px-6 flex flex-col md:flex-row items-center justify-center gap-x-6 gap-y-2 text-center text-xs text-zinc-500">
        <span>© {new Date().getFullYear()} ANV Asesores — Acta Non Verba Asesores, S.L.</span>
        <span className="hidden md:inline text-zinc-700">·</span>
        <span className="flex items-center gap-4">
          <Link to="/aviso-legal" className="hover:text-[#D4AF37]" data-testid="footer-aviso-legal">Aviso legal</Link>
          <Link to="/privacidad" className="hover:text-[#D4AF37]" data-testid="footer-privacidad">Privacidad</Link>
          <Link to="/cookies" className="hover:text-[#D4AF37]" data-testid="footer-cookies">Cookies</Link>
        </span>
      </div>
    </footer>
  );
}
